import { type FC, type PropsWithChildren } from "react";

import { TooltipIntent } from "widgets";

import { type IEditable } from "../../../../redux/modules/data-editing.js";
import { TooltipController } from "../../overlays/components/OverlayControllers.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";

const EditDataValidation: FC<PropsWithChildren<IAgGridCellProps>> = (props) => {
  const { colDef } = props;

  const data: IEditable = props.data;
  const validationMessage = data.editing?.[colDef.colId]?.validationError;
  return (
    <TooltipController
      content={validationMessage}
      intent={TooltipIntent.Danger}
      overlayOptions={{ isDisabled: !validationMessage }}
    >
      {(tooltipTriggerProps) => (
        <div
          ref={tooltipTriggerProps.ref}
          onPointerEnter={tooltipTriggerProps.onPointerEnter}
          onPointerLeave={tooltipTriggerProps.onPointerLeave}
        >
          {props.children}
        </div>
      )}
    </TooltipController>
  );
};

export default EditDataValidation;
